import { IGetReportFolhaPagamentoDetalhadaUseCase } from "../../../presentation/useCases/read/get_report_folha_pagamento_detalhada_use_case";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IReportsRepository } from "../../repositories/reports_repository";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";

/**
 * GetReportFolhaPagamentoDetalhadaUseCase
 */

export class GetReportFolhaPagamentoDetalhadaUseCase implements IGetReportFolhaPagamentoDetalhadaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportFolhaPagamentoDetalhada(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    folhaPagamentos: number[] | null,
    centroCustos: number[] | null,
    funcionarios: number[] | null,
    cargos: number[] | null,
    dataCadastroDe: Date | null,
    dataCadastroAte: Date | null,
    dataPagamentoDe: Date | null,
    dataPagamentoAte: Date | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportFolhaPagamentoDetalhada(
      requiredMimeType,
      idUsuario,
      folhaPagamentos,
      centroCustos,
      funcionarios,
      cargos,
      dataCadastroDe,
      dataCadastroAte,
      dataPagamentoDe,
      dataPagamentoAte,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `folha_pagamento_detalhada_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
